import { TOPIC_ROLE, TOPIC_SUFFIX } from '../catalog/link';
import type { TopicRole } from '../catalog/link';

/**
 * Topics are the serial number plus a fixed suffix, e.g. `888854/toCloudRCU`.
 * The serial is the firmware's own, the one discovery prints and the technician
 * typed into RCU details — not the installer's device ID.
 */
export const topicFor = (serial: string, role: TopicRole): string =>
  `${serial.trim()}${TOPIC_SUFFIX[role]}`;

export interface TopicSet {
  readonly serial: string;
  readonly commands: string;
  readonly events: string;
  readonly logs: string;
  readonly coredump: string;
}

/** All four topics at once, so a screen can show exactly what is subscribed. */
export const topicSet = (serial: string): TopicSet => ({
  serial: serial.trim(),
  commands: topicFor(serial, TOPIC_ROLE.COMMANDS),
  events: topicFor(serial, TOPIC_ROLE.EVENTS),
  logs: topicFor(serial, TOPIC_ROLE.LOGS),
  coredump: topicFor(serial, TOPIC_ROLE.COREDUMP),
});

/** Every topic the console uses, in the order the Link sheet lists them. */
export const allTopics = (topics: TopicSet): readonly string[] => [
  topics.commands,
  ...SUBSCRIBED_ROLES.map((role) => topics[role]),
];

/** Roles the console listens to: the command topic is published, not read. */
export const SUBSCRIBED_ROLES = [
  TOPIC_ROLE.EVENTS,
  TOPIC_ROLE.LOGS,
  TOPIC_ROLE.COREDUMP,
] as const satisfies readonly TopicRole[];
